module.exports = __webpack_public_path__ + "media/assets/images/flags/fi-375cd51ea45db07c3b845b373ed9723f.svg";